import React, { HTMLAttributes } from 'react';
import { Col, Row } from 'react-bootstrap';

import cx from 'classnames';

import CircleAvatarOverflow from 'components/CircleAvatarOverflow/CircleAvatarOverflow';
import LinkButtonRow from 'components/LinkButtonRow/LinkButtonRow';
import SectionWithContainer from 'components/PageBlocks/SectionWithContainer/SectionWithContainer';
import { ICampaignContent } from 'models/campaignContent';

interface IProps extends HTMLAttributes<HTMLElement> {
  campaignContent: ICampaignContent;
}

const CrossReferenceBannerSectionCampaignContent: React.FC<IProps> = ({
  campaignContent,
  className,
  ...props
}) => {
  return (
    <SectionWithContainer {...props} className={cx('bg-light-grey', className)}>
      <Row className="justify-content-center justify-content-md-start flex-wrap flex-lg-nowrap">
        {campaignContent.content_media.url && (
          <Col xs="auto" className="mb-4 mb-md-0">
            <CircleAvatarOverflow size="lg" className="bg-white">
              <img
                src={campaignContent.content_media.url}
                alt={campaignContent.content_media_alt}
              />
            </CircleAvatarOverflow>
          </Col>
        )}
        <Col lg="auto" className="flex-shrink-1">
          {campaignContent.heading && (
            <h1
              data-content="campaign_content_heading"
              className="text-center text-md-left"
            >
              {campaignContent.heading}
            </h1>
          )}
          {campaignContent.sub_heading && (
            <h4
              data-content="campaign_content_sub_heading"
              className="center text-md-left-left"
            >
              {campaignContent.sub_heading}
            </h4>
          )}
          {campaignContent.content_brief && (
            <div
              data-content="campaign_content_content_brief"
              dangerouslySetInnerHTML={{
                __html: campaignContent.content_brief,
              }}
            />
          )}
          <LinkButtonRow links={campaignContent.links || []} />
        </Col>
      </Row>
    </SectionWithContainer>
  );
};

export default CrossReferenceBannerSectionCampaignContent;
